import { CmsApiSignUpBlockData } from 'modules/cms/api/types/CmsApiSignUp';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsSignUpBlock } from './CmsSignUpBlock';

export const CmsSignUpBlockMapping: CmsBlockMapping<CmsApiSignUpBlockData> = {
  invariant: [],
  width: CmsBlockWidth.FULL,
  Component: CmsSignUpBlock,
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type '(props: Cms... Remove this comment to see the full error message
  AmpComponent: null,
};
